{
    "PageTitle_auth": "Autenticazione",
    "NAME": "Router",
    "PageTitle_presence": "Presenza",
    "PageTitle_changePassword": "Cambiare la password",
    "PageTitle_forgotPassword": "Ha dimenticato la password",
    "PageTitle_changeLanguage": "Cambia lingua",
    "PageTitle_resetPassword": "Reimposta password",
    "PageTitle_termsAndConditions": "Termini e Condizioni",
    "PageTitle_cookiePolicy": "Informativa sui cookie",
    "PageTitle_privacyPolicy": "politica sulla riservatezza",
    "PageTitle_mfa": "Autenticazione a più fattori",
    "PageTitle_teamsAuth": "Autenticazione Teams",
    "PageTitle_insights": "Approfondimenti",
    "PageTitle_crmIntegration": "Integrazione CRM",
    "PageTitle_changeUserAgent": "Cambia agente utente",
    "PageTitle_clientConfiguration": "Configurazione del cliente",
    "PageTitle_CRMConfiguration": "Configurazione CRM",
    "PageTitle_adminControl": "Controlli amministrativi",
    "PageTitle_admin": "Amministrazione",
    "PageTitle_cme": "ECM",
    "PageTitle_status": "Stato del server applicativo",
    "PageTitle_licences": "Licenze",
    "PageTitle_licenceManagement": "Gestione delle licenze",
    "PageTitle_telsys": "Server di telefonia",
    "PageTitle_users": "Utenti dell'applicazione",
    "PageTitle_partitions": "Pareti divisorie",
    "PageTitle_device": "Dispositivi",
    "PageTitle_agent": "agenti",
    "PageTitle_code": "Codici",
    "PageTitle_auditTrail": "Traccia di controllo",
    "PageTitle_logManagement": "Gestione dei log",
    "PageTitle_loggingSettings": "Impostazioni di registrazione",
    "PageTitle_telModuleStatus": "Stato del modulo telefonico",
    "PageTitle_recording": "Registrazione",
    "PageTitle_messages": "Messaggi",
    "PageTitle_database": "Schermata",
    "PageTitle_directory": "Elenco",
    "PageTitle_cxScore": "Punteggio CX",
    "PageTitle_cxScore-cx-score": "Punteggio CX",
    "PageTitle_cxScore-overview": "Punteggio CX",
    "PageTitle_cxScore-calls": "Punteggio CX",
    "PageTitle_cxiDashboard": "Pannello di controllo CXI"
}